var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28462_3875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.05176e-05 10.0006C-3.05176e-05 14.3002 2.71372 17.9656 6.52165 19.3785L7.39126 10.0005L6.52165 0.622559C2.71372 2.03553 -3.05176e-05 5.70092 -3.05176e-05 10.0006Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10C20.0001 4.47719 15.5229 0 10.0001 0C8.77691 0 7.60515 0.220039 6.52179 0.621992V19.378C7.60515 19.78 8.77691 20 10.0001 20C15.5229 20 20.0001 15.5228 20.0001 10Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52185 13.4789C8.44283 13.4789 10.0001 11.9217 10.0001 10.0007C10.0001 8.07972 8.44283 6.52246 6.52185 6.52246C4.60087 6.52246 3.04361 8.07972 3.04361 10.0007C3.04361 11.9217 4.60087 13.4789 6.52185 13.4789Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56479 8.26074V10.4347C4.56479 11.5152 5.44073 12.3912 6.52131 12.3912C7.6019 12.3912 8.47784 11.5152 8.47784 10.4347V8.26074H4.56479Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52185 11.0867C6.16224 11.0867 5.86966 10.7941 5.86966 10.4345V9.56494H7.17399V10.4345C7.17399 10.7941 6.88142 11.0867 6.52185 11.0867Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28462_3875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.0bda26a50ef2faf800c5fb30c74e04fa.svg";
export { ForwardRef as ReactComponent };